import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseDeliverycalendar() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getDeliveryTypes = (callback, bool) => {
    MyAxios.get(`Admin_DeliveryCalendar`, {
      headers: {
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCalendarMonths = (Conditions, callback) => {
    MyAxios.get(`Admin_DeliveryCalendar/month`, {
      headers: {
        Conditions: JSON.stringify(Conditions),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCalendardays = (Conditions, callback) => {
    MyAxios.get(`Admin_DeliveryCalendar/day`, {
      headers: {
        Conditions: JSON.stringify(Conditions),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const setDeliveryTimes = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DeliveryCalendar`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getDeliveryTypes,
    getCalendarMonths,
    getCalendardays,
    setDeliveryTimes,
  };
}
